module.exports = require("./../../_gen/starling/display/MovieClip");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/MovieClip.js
// module id = 170
// module chunks = 0